import React from 'react';

const Header = () => {
    return ( 
    <header className="bg-alert">
        <h1>Busca recetas</h1>
    </header>
    );
}
 
export default Header;